<template>
  <div class="md-layout">
    <div id="objectHeaderContentHidden" style="display: none;">
      <div><md-icon class="icon-color">{{list.pageIcon}}</md-icon></div>
      <div>
        <h1 class="md-title icon-color">{{ $route.name }}</h1>
      </div>
    </div>

    <ElasticList :list="list"></ElasticList>
  </div>
</template>

<script>
  import ElasticList from "@/components/DynamicForm/ElasticList";
  import Page from '@/mixins/Page';

  export default {
    mixins: [Page],
    components: {
      ElasticList
    },
    data() {
      return {
        list: {
          hideListHeader: true,
          editPath: "accounts",
          pageTitle: "Accounts",
          pageIcon: "work",
          linkRows: true,
          listQueryId: "searchAccountCustoms",
          deleteQueryId: "deleteAccount",
          responseFieldName: "searchAccounts",
          itemActions: [
            {
              class: "md-just-icon md-warning md-simple",
              icon: "description",
              click: "handleEdit"
            },
            {
              class: "md-just-icon md-danger md-simple",
              icon: "close",
              click: "handleAccountDelete"
            }
          ],
          columns: {
            company: { label: "Company", sortable: false, searchable: true, display: true, nested: "name"  },
            name: { label: "DBA Name", sortable: true },
            nameLegal: { label: "Legal Name", sortable: true },
            addressPhysical: { label: "Address", sortable: false },
            createdAt: { label: "Created", sortable: true, dateFilter: true },
          },
          perPageOptions: [5, 10, 20, 25, 50],
          defaults: {
            sort: 'createdAt',
            sortDir: 'desc',
            perPage: 10,
          },
          fuseSearch: null,
          formatResponse: (data) => {
            let result = [];
            if (data && data.searchAccounts && data.searchAccounts.items && data.searchAccounts.items.length) {
              let items = data.searchAccounts.items;
              items.forEach((item) => {
                /** Format addresses for display */
                ['addressPhysical', 'addressMailing'].forEach(addressName => {
                  let itemAddress = item[addressName];
                  if (typeof itemAddress !== 'undefined' && itemAddress) {
                    item[addressName] = this.$format.JsonAddressToString(itemAddress);
                  }
                });

                /**
                 * ATLAS-935 Company > Account tab: DB value is showing in Address column for State and Country
                 * 
                 * Remove Country code and underscores from Address fields
                 */
                if(item.addressPhysical) {
                  item.addressPhysical = item.addressPhysical.replace(/US_|CA_|_/g, ' ').trim();
                }
                if(item.addressMailing) {
                  item.addressMailing = item.addressMailing.replace(/US_|CA_|_/g, ' ').trim();
                }

                result.push(item);
              })
            }
            return result;
          },
        },
      };
    },
  };
</script>

<style>
</style>
